import React from "react";
import { ListGroup } from "react-bootstrap";
// import getStage from "../../lib/getStage";
import getDomain from "../../lib/getDomain";

export default function Accounts({ accounts, handleAccountChosen }) {
  function getAccountName(user_chosen_company, company_name, current_screen) {
    if (user_chosen_company) return user_chosen_company;
    if (company_name) return company_name;
    if (current_screen !== "home") return "Continue application";
    return "Personal account";
  }

  const list_items = accounts.map((x, index) => {
    const { user_chosen_company, company_name, current_screen, id } = x;
    return (
      <ListGroup.Item
        key={index}
        action
        style={{ backgroundColor: "#fcb034", color: "white", marginBottom: 20 }}
        onClick={() => {
          const screen = current_screen === "home" ? "" : current_screen;
          handleAccountChosen(id, screen);
        }}
      >
        {getAccountName(user_chosen_company, company_name, current_screen)}
      </ListGroup.Item>
    );
  });

  return (
    <div
      className="background-foto accounts"
      style={{
        // width: "100%",
        // minHeight: "100vh",
        // display: "flex",
        backgroundImage: `url(https://assets.orenda.finance/${getDomain}/background.jpg)`,
        // backgroundSize: "cover",
        // backgroundPosition: "center",
        // justifyContent: "center",
        // alignItems: "center",
      }}
    >
      <div
        className="content-box"
        style={{
        //   display: "flex",
        //   justifyContent: "center",
        //   alignItems: "center",
        //   flexDirection: "column",
        //   backgroundColor: "white",
        //   padding: 20,
        //   borderRadius: "15px",
        //   maxWidth: 250,
        }}
      >
        <h6 style={{ marginBottom: 30 }}>Please select account</h6>
        <ListGroup>{list_items}</ListGroup>
      </div>
    </div>
  );
}
